import React from 'react';
import AppRouter from './AppRouter';
import { AllWalletsProvider } from './services/wallets/AllWalletsProvider';

function App() {
  return (
    <AllWalletsProvider>
      <AppRouter />
    </AllWalletsProvider>
  );
}

export default App;